<div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div>

<div class="container">
    <div class="row no-gutters justify-content-center">
        <div class="col-md-12">
            <div class="wrapper">
                <div class="row g-0">
                    <div class="col-lg-12">
                        <div class="contact-wrap w-100 p-2 ">
                            <h3>
                                Careers
                            </h3>
                            <div class="text-center" *ngIf="isAPIExecute">
                                <i class="fa fa-check-circle tick-icon"
                                    style="display: block; margin: 0 auto;"></i>
                                <h2 class="mt-2">
                                    Thank You
                                </h2>
                                <p>Our HR Team will contact you soon.</p>
                            </div>
                            <form *ngIf="!isAPIExecute" id="careersForm"
                                [formGroup]="careersForm" name="careersForm"
                                class="careersForm" method="POST">
                                <div class="row mb-2">
                                    <div class="col-3">
                                        <label for="nameInput"
                                            class="form-label">Name:</label>
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control"
                                            formControlName="name">
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">
                                        <label for="emailInput"
                                            class="form-label">Email:</label>
                                    </div>
                                    <div class="col-9">
                                        <input type="email" class="form-control"
                                            formControlName="email">
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">
                                        <label for="mobileInput"
                                            class="form-label">Mobile:</label>
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control"
                                            formControlName="mobile">
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">
                                        <label for="subject"
                                            class="form-label">Subject:</label>
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control"
                                            formControlName="subject">
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-3">
                                        <label for="attach_your_cv"
                                            class="form-label">Attach Your
                                            CV:</label>
                                    </div>
                                    <div class="col-9">
                                        <input type="file" class="form-control"
                                            formControlName="attach_your_cv"
                                            (change)="handleFileChange($event)"
                                            accept="application/pdf">
                                    </div>
                                </div>

                                <button type="button" class="btn btn-primary"
                                    (click)="onDone()">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>